import Phaser from "phaser";
import { GAMES, type GameDef } from "../games/registry";
import { domText } from "../dom";

const COLOR_BG = 0xf5e6d3;
const COLOR_CARD = 0xfaf2e8;
const COLOR_CARD_PRESSED = 0xeadac0;
const COLOR_BORDER = 0xd4a574;

export class MenuScene extends Phaser.Scene {
  constructor() {
    super("menu");
  }

  create() {
    this.cameras.main.setBackgroundColor(COLOR_BG);
    this.layout();
    this.scale.on("resize", this.layout, this);
  }

  private layout = () => {
    this.children.removeAll();
    const { width: w, height: h } = this.scale;

    const titleSize = Math.round(Math.min(w, h) * 0.09);
    const titleEl = document.createElement("div");
    titleEl.className = "arc-text arc-menu-title";
    titleEl.textContent = "arcade";
    titleEl.style.fontSize = `${titleSize}px`;
    this.add.dom(w / 2, h * 0.16, titleEl).setOrigin(0.5).setDepth(10);

    const subEl = document.createElement("div");
    subEl.className = "arc-text arc-menu-sub";
    subEl.textContent = "second-screen games";
    subEl.style.fontSize = `${Math.round(titleSize * 0.42)}px`;
    this.add.dom(w / 2, h * 0.16 + titleSize * 0.85, subEl).setOrigin(0.5).setDepth(10);

    const cardW = Math.min(w * 0.86, 380);
    const cardH = 96;
    const gap = 14;
    const startY = h * 0.36;

    GAMES.forEach((g, i) => {
      const y = startY + i * (cardH + gap) + cardH / 2;
      this.makeCard(w / 2, y, cardW, cardH, g);
    });

    void domText;
  };

  private makeCard(x: number, y: number, w: number, h: number, g: GameDef) {
    const container = this.add.container(x, y);
    const radius = 18;

    const gfx = this.add.graphics();
    const drawBg = (color: number) => {
      gfx.clear();
      gfx.fillStyle(color, 1);
      gfx.fillRoundedRect(-w / 2, -h / 2, w, h, radius);
      gfx.lineStyle(2, COLOR_BORDER, 1);
      gfx.strokeRoundedRect(-w / 2, -h / 2, w, h, radius);
    };
    drawBg(COLOR_CARD);
    container.add(gfx);
    container.setSize(w, h);
    container.setInteractive(
      new Phaser.Geom.Rectangle(-w / 2, -h / 2, w, h),
      Phaser.Geom.Rectangle.Contains,
    );

    // DOM-rendered card content layered above the graphics.
    const iconEl = document.createElement("div");
    iconEl.className = "arc-text arc-card-icon";
    iconEl.textContent = g.icon;
    this.add.dom(x - w / 2 + 38, y, iconEl).setOrigin(0.5).setDepth(11);

    const nameEl = document.createElement("div");
    nameEl.className = "arc-text arc-card-name";
    nameEl.textContent = g.name;
    this.add.dom(x - w / 2 + 88, y - 14, nameEl).setOrigin(0, 0.5).setDepth(11);

    const descEl = document.createElement("div");
    descEl.className = "arc-text arc-card-desc";
    descEl.textContent = g.description;
    descEl.style.maxWidth = `${w - 110}px`;
    descEl.style.whiteSpace = "normal";
    this.add.dom(x - w / 2 + 88, y + 16, descEl).setOrigin(0, 0.5).setDepth(11);

    let pressed = false;
    container.on("pointerdown", () => {
      pressed = true;
      drawBg(COLOR_CARD_PRESSED);
    });
    const release = (fire: boolean) => {
      if (!pressed) return;
      pressed = false;
      drawBg(COLOR_CARD);
      if (fire) this.scene.start(g.key);
    };
    container.on("pointerup", () => release(true));
    container.on("pointerout", () => release(false));
    container.on("pointercancel", () => release(false));

    return container;
  }
}
